import { ReduxState } from 'src/store/types';

export const connectionSelector = (state: ReduxState) =>
  state.connections.connection;
